const ipadPopup = () => {
  const ipadTrigger = document.querySelectorAll('.popup-trigger')
  const ipadOverlay = document.querySelectorAll('.popup-overlay')
  const popupTop = document.querySelector('.popup-wrapper-top')

  const clickAction = (elem1, elem2, elem3) => {
    elem1.addEventListener('click', () => {
      elem2.classList.remove('active')
      elem3.classList.remove('active')
    })
  }

  const addClass = (elem1, elem2) => {
    elem1.classList.add('active')
    elem2.classList.add('active')
  }

  if (ipadTrigger.length && ipadOverlay.length) {
    ipadTrigger.forEach((element, index) => {
      ipadOverlay.forEach(overlay => {
        const closeBtn = overlay.querySelector('.popup-close')

        element.addEventListener('click', () => {
          if (index === 0 && overlay.classList.contains('popup-overlay-1')) {
            clickAction(closeBtn, popupTop, overlay)
            addClass(overlay, popupTop)
          } else if (index === 1 && overlay.classList.contains('popup-overlay-2')) {
            clickAction(closeBtn, popupTop, overlay)
            addClass(overlay, popupTop)
          } else if (index === 2 && overlay.classList.contains('popup-overlay-3')) {
            clickAction(closeBtn, popupTop, overlay)
            addClass(overlay, popupTop)
          } else if (index === 3 && overlay.classList.contains('popup-overlay-4')) {
            clickAction(closeBtn, popupTop, overlay)
            addClass(overlay, popupTop)
          }
        })

      })
    })
  }
}

ipadPopup()